/** @format */

import { DynamicTemplateLoader, WINDOW_PROVIDERS } from '@shared/data-access/services';
import { NO_ERRORS_SCHEMA, NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';
import { HomeComponent } from './home-component/home.component';

@NgModule({
  imports: [CommonModule],
  declarations: [HomeComponent],
  providers: [
    // TODO: HomrDataServiceMock
    DynamicTemplateLoader,
    WINDOW_PROVIDERS,
  ],
  exports: [HomeComponent],
  schemas: [NO_ERRORS_SCHEMA],
})
export class HomeModule {}
